import React from 'react';

export function ToggleLockIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
      <g clipPath="url(#clip0_19785_7606)">
        <rect x="0.5" width="20" height="20" rx="10" fill="black" />
        <path
          d="M9.5 6.875V7.75C9.5 8.30228 9.94771 8.75 10.5 8.75C11.0523 8.75 11.5 8.30228 11.5 7.75V6.875C11.5 6.32272 11.0523 5.875 10.5 5.875C9.94772 5.875 9.5 6.32272 9.5 6.875Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20ZM7.625 8.75C7.83211 8.75 8 8.58211 8 8.375V6.875C8 5.49429 9.11929 4.375 10.5 4.375C11.8807 4.375 13 5.49429 13 6.875V8.375C13 8.58211 13.1679 8.75 13.375 8.75C14.2034 8.75 14.875 9.42157 14.875 10.25V13.4214C14.875 14.2498 14.2034 14.9214 13.375 14.9214H7.625C6.79657 14.9214 6.125 14.2498 6.125 13.4214V10.25C6.125 9.42157 6.79657 8.75 7.625 8.75Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_19785_7606">
          <rect x="0.5" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
